<template>
<v-app id="inspire">

    <v-main style="background-color: #24292d;font-family: 'Poppins', sans-serif !important;">
      <cabecerabaja class=" hidden-md-only hidden-lg-only hidden-xl-only" />

      <v-container fluid fill-height align-start>
    <v-row justify="center" align="stretch">
      <v-col v-if="negocio.tipoNegocio.id ===2 || negocio.tipoNegocio.id ===1  "  class="d-flex flex-column"  md="3" lg="3" cols="12">
        <v-card  color="#393E46" class="flex d-flex flex-column">
          <v-card-title class="flex">
            Temporadas
          </v-card-title>
          <v-card-text class="flex">
            <v-row>
                    <v-col md="12" lg="12" cols="12">

            <v-autocomplete v-model="idtemporada" :items="temporadas" item-text="temporada" item-value="id" @change="damesocioss" label="Escoger Temporada">
            </v-autocomplete>
                  </v-col>

            </v-row>
            <v-row>
              <v-col>
                <v-btn color="primary" @click="damesocioss"><span class=" hidden-sm-only hidden-xs-only">Cargar de Nuevo</span><v-icon class=" hidden-md-only hidden-lg-only hidden-xl-only">fas fa-sync-alt</v-icon></v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col md="3" lg="3" cols="12" class="d-flex flex-column">
        <v-card  color="#393E46" class="flex d-flex flex-column">
          <v-card-title class="flex">
            Bajar Excel
          </v-card-title >
          <v-card-text class="flex">
            <v-row>
                    <v-col md="12" lg="12" cols="12">
 <vue-excel-xlsx
                                               class   = "btn"
    :data="personas"
    :columns="columns"
    :filename="'Socios'"

    >
   <v-btn v-if="diexcel" style="background-color: #6D9886;"> <span class=" hidden-sm-only hidden-xs-only">Bajar Excel</span><v-icon class=" hidden-md-only hidden-lg-only hidden-xl-only">fas fa-file-excel</v-icon></v-btn>
</vue-excel-xlsx>
                  </v-col>

            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row  >
      <v-col md="12" lg="12" cols="12">
        <v-alert
            :value="alerterror"
            color="red"
            dark
            dismissible
            border="top"
            transition="scale-transition"
        >
          {{texterror}}
        </v-alert>
        <v-alert
        :value="alertborrador"
        color="red"
        dark
        dismissible
        border="top"
        transition="scale-transition"
      >
      Su socios se borro con éxito.
       </v-alert>
       <v-alert
        :value="alertnuevo"
        color="primary"
        dark
        dismissible
        border="top"
        transition="scale-transition"
      >
      Su socios se agrego con éxito.
       </v-alert>
       <v-alert
        :value="alerteditar"
        color="green"
        dark
        dismissible
        border="top"
        transition="scale-transition"
      >
      Su socios se edito con éxito.
       </v-alert>
        <h1 class="hidden-md-only hidden-lg-only hidden-xl-only">Socios</h1>

        <v-data-table
      :headers="headers"
      :items="socios"
      :single-expand="singleExpand"
            :expanded.sync="expanded"
      :search="search"
      disable-sort
            item-key="id"
            show-expand
      :loading="progr"
      no-data-text="No hay datos disponibles para mostrar."
      no-results-text="No hay resultados para la búsqueda."
      loading-text="Cargando... Por favor espere."
      style="background-color: #393E46;"
    >
      <template v-slot:top>
        <v-toolbar flat >
          <v-toolbar-title class="hidden-sm-only hidden-xs-only">Socios</v-toolbar-title>
          <v-btn @click="damesocioss"><v-icon>fas fa-sync-alt</v-icon></v-btn>

          <v-divider
            class="mx-4"
            inset
            vertical
          ></v-divider>
          <v-text-field v-model="search" @change="damesocioss" label="Buscar" class="mx-4"></v-text-field>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="500px">
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="6" sm="6" md="6">
                      <v-text-field v-model="editedItem.socioPrincipal.personaNombre" label="Nombre"></v-text-field>
                    </v-col>
                      <v-col cols="6" sm="6" md="6">
                      <v-text-field v-model="editedItem.socioPrincipal.personaApellidoPaterno" label="Apellido Paterno"></v-text-field>
                    </v-col>
                    <v-col cols="6" sm="6" md="6">
                      <v-text-field v-model="editedItem.socioPrincipal.personaApellidoMaterno" label="Apellido Materno"></v-text-field>
                    </v-col>
                    <v-col cols="6" sm="6" md="6">
                      <v-text-field v-model="editedItem.socioPrincipal.personaDni" label="Apellido Materno"></v-text-field>
                    </v-col>
                    <v-col cols="6" sm="6" md="6">
                      <v-text-field type="number" v-model="editedItem.socioPrincipal.personaTelefono" label="Telefono"></v-text-field>
                    </v-col>
                    <v-col cols="6" sm="6" md="6">
                      <v-text-field  v-model="editedItem.socioPrincipal.personaDireccion" label="Direccion"></v-text-field>
                    </v-col>

                    <v-col cols="6" sm="6" md="6">
                      <v-menu
                              ref="menu1"
                              v-model="menu1"
                              :close-on-content-click="false"
                              transition="scale-transition"
                              offset-y
                              max-width="290px"
                              min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field v-model="editedItem.socioPrincipal.personaFechaNacimiento" label="Fecha"
                                        hint="YYYY-MM-DD" persistent-hint
                                        @blur="date = formatDatee(editedItem.socioPrincipal.personaFechaNacimiento)"
                                        v-on="on"
                                        :formatter="format"
                                        prepend-icon="fas fa-calendar" ></v-text-field></template>
                        <v-date-picker
                                v-model="date"
                                no-title
                                min="1950-01-01"
                                @input="menu1 = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="6" sm="6" md="6">
                      <v-text-field  v-model="editedItem.referido" label="Referido"></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
                <v-btn color="blue darken-1" text @click="save">Grabar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogdelete" persistent max-width="350">
        <v-card>
          <v-card-title class="headline">Desea eliminar esta socios?</v-card-title>
          <v-card-text>Estos datos no se volveran a visualizar en el sistema.</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="close">No</v-btn>
            <v-btn color="primary darken-1" text @click="borralo">SI</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
          <v-dialog v-model="dialogimage"  max-width="500">
            <v-card>
              <v-card-title class="headline">Zoom</v-card-title>

              <a :href="editedItem.socioPrincipal.personaFoto" target="_blank"><v-img :src="editedItem.socioPrincipal.personaFoto"  /></a>

            </v-card>
          </v-dialog>
          <v-dialog v-model="dialoguploadimage"  persistent max-width="600">
            <v-card>
              <v-card-title class="headline">Subir nueva Foto?</v-card-title>
              <v-card-text>
                <v-row>
                  <v-col md="12" lg="12" cols="12">
                    <v-img :src="editedItem.socioPrincipal.personaFoto"  />
                  </v-col>
                  <v-col md="12" lg="12" cols="12">
                    <v-file-input
                        label="Subir Foto"
                        accept="image/*"
                        filled
                        chips
                        v-model="imagen"
                        @change="onFileFotoChange"
                        prepend-icon="mdi-camera"
                    ></v-file-input>

                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="green darken-1" text @click="dialoguploadimage=false">Cerrar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialoguploadimagedni" persistent  max-width="600">
            <v-card>
              <v-card-title class="headline">Subir nueva Foto del DNI?</v-card-title>
              <v-card-text>
                <v-row>
                  <v-col md="12" lg="12" cols="12">
                    <v-img :src="editedItem.socioPrincipal.personaFotoDni"  />
                  </v-col>
                  <v-col md="12" lg="12" cols="12">
                    <v-file-input
                        label="Subir Foto"
                        accept="image/*"
                        filled
                        chips
                        v-model="imagen"
                        @change="onFileChange"
                        prepend-icon="mdi-camera"
                    ></v-file-input>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="green darken-1" text @click="dialoguploadimagedni=false">Cerrar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <v-icon
          small
          color="blue"
          class="mr-2"
          @click="editItem(item)"
        >
          fas fa-edit
        </v-icon>
        <v-icon
          small
          color="error"
                    class="mr-2"
          @click="deleteItem(item)"
        >
          fas fa-minus-circle
        </v-icon>
        <v-icon
                small
                color="green"
                class="mr-2"
                @click="cameraItem(item)"
        >
          fas fa-camera
        </v-icon>
        <v-icon
            small
            color="white"
            class="mr-2"
            @click="dniItem(item)"
        >
          far fa-id-card
        </v-icon>
          <v-icon
                  small
                  color="white"
                  class="mr-2"
                  @click="verCarnet(item)"
          >
              far fa-eye
          </v-icon>
        <v-autocomplete class="mr-4" v-model="item.estadoCarnet" :items="estadocarnets" item-color="estadoCarnetColor"  item-text="estadoCarnet" persistent-hint
                          return-object
                         @change="cambiaEstado(item)"
                         single-line >
          <template v-slot:selection="data">
           <v-chip :color="data.item.color">  {{ data.item.estadoCarnet }}</v-chip>
          </template>
        </v-autocomplete>
      </template>
          <template v-slot:[`item.esctcarn`]="{ item }">
            <v-autocomplete  v-model="item.tipoCarnet.tipoCarnetId" :items="tiposcarnets"  item-value="id"  item-text="tipoCarnet" hint="Tipo de Carnet" persistent-hint
                             @change="cambiaTipoCarnet(item)"
                             single-line label="Escoger Tipo de Carnet"></v-autocomplete>
          </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="damesocioss">Cargar de Nuevo</v-btn>
      </template>
          <template v-slot:[`item.socioPrincipal.personaFechaNacimiento`]="{ item }">
            {{formatFecha(item.socioPrincipal.personaFechaNacimiento)}}
          </template>
      <template v-slot:expanded-item="{ headers, item }">
              <td class="pa-4" :colspan="headers.length">
       <v-row cols="1">
         <v-col md="3" lg="3" >
           <v-img :src="item.socioPrincipal.personaFoto" contain height="200px"    width="200px"        @click="zoomItem(item)"
           />
         </v-col>
         <v-col md="5" lg="5" >
           <v-row>
             <v-col md="12" lg="12" >
             {{item.socioPrincipal.personaNombre}} {{item.socioPrincipal.personaApellidoPaterno}} {{item.socioPrincipal.personaApellidoMaterno}} DNI: {{item.socioPrincipal.personaDni}}
           </v-col>
             <v-col md="12" lg="12">
               {{item.socioPrincipal.personaEmail}} - {{item.socioPrincipal.personaTelefono}}
             </v-col>
             <v-col md="12" lg="12">
               {{item.socioPrincipal.personaDireccion}} - {{item.socioPrincipal.personaDistrito.distrito}}
             </v-col>
             <v-col md="12" lg="12" >
               {{item.tipoMembresia.tipoMembresia}} - {{item.tipoCarnet.tipoCarnet}}
             </v-col>
           </v-row>
         </v-col>
         <v-col md="3" lg="3" >
           <vue-qr :text="item.codigoUnico" :size="200" />
         </v-col>
       </v-row>
              </td>

      </template>
    </v-data-table>

      </v-col>
    </v-row>
    <leftmenu :abreviado="abreviado" />
    <v-overlay :value="overlay">
      <v-img
          src="@/assets/loadtunay.gif"

      />
    </v-overlay>
  </v-container>
    </v-main>
  </v-app>
</template>
<style>
    .dropzone-custom-content {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
    }

    .dropzone-custom-title {
        margin-top: 0;
        color: #00b782;
    }

    .subtitle {
        color: #314b5f;
    }
</style>
<script>
import { mapGetters } from "vuex";
import leftmenu from '../../general/leftmenu';
import axios from 'axios';
import VueQr from 'vue-qr'

import moment from "moment";
import firebase from 'firebase/compat/app';
import Cabecerabaja from "@/components/general/cabecerabaja";

export default {
  title: 'Socios | Tunay Mi acceso de bolsillo',

  components: {
    Cabecerabaja,
    leftmenu,
    VueQr
  },
    data: () => ({
      drawer: null,
      idnegocio: 0,
      negociotg:[],
      negocio:{},
        grupousuario:{},
      idtemporada: 0,
      progr: true,
      abreviado:'NN',
      diexcel: false,
      overlay: false,
      token:'',
      singleExpand: true,
      expanded:[],
      alertborrador: false,
      alertnuevo: false,
      alerteditar: false,
      alerterror:false,
      texterror:'',
      dialog: false,
      columns : [
                    {
                        label: "Nombre",
                        field: "nombre",
                    },
                      {
                        label: "Apellido Paterno",
                        field: "appaterno",
                      },
                    {
                        label: "DNI",
                        field: "dni",
                    },
                    {
                        label: "Telefono",
                        field: "telefono",
                    },

                    {
                      label: "Email",
                      field: "email",
                    },
                    {
                        label: "Direccion",
                        field: "direccion",
                    },
                    {
                        label: "Distrito",
                        field: "distrito",
                    },
        {
          label: "Referido",
          field: "referido",
        },
        {
          label: "Edad",
          field: "edad",
        },
                ],
      dialogdelete: false,
      dialogimage: false,
      dialoguploadimage: false,
      dialoguploadimagedni: false,
      date: new Date().toISOString().substr(0, 10),
      menu1: false,
      socios: [],
      pagina: 1,
      cantidad: 0,
      tamanio: 10,
      imagen:null,
      personas:[],
      distritos: [{id:0,distrito:"Escoger Distrito",ciudad:{}}],
      tiposcarnets: [],
      temporadas: [],
      estadocarnets: [],
      search: '',
      editedIndex: -1,
      editedItem: {
        id:0,
        fecha: new Date().toISOString().substr(0, 10),
        estadoCarnet: {},
        formaEnvio: {},
        tipoPago : {},
        tipoMembresia: {},
        tipoCarnet:{},
        temporada:{},
        contacto:{},
        referido:'',
        nroboleta: '',
        valorpago:0,
        aceptoCondicion:false,
        condicionAceptada:'',
        socioPrincipal:{},
        negocio: {},
        periocidad:{},
        fechaInicio:null,
        fechaFin:null
      },
    defaultItem: {
      id:0,
      fecha: new Date().toISOString().substr(0, 10),
      estadoCarnet: {},
      formaEnvio: {},
      tipoPago : {},
      tipoMembresia: {},
      tipoCarnetSocio:{},
      temporada:{},
      contacto:{},
      referido:'',
      nroboleta: '',
      valorpago:0,
      aceptoCondicion:false,
      condicionAceptada:'',
      socioPrincipal:{},
      negocio: {},
      periocidad:{},
      fechaInicio:null,
      fechaFin:null
    },
    headers: []
  }),
  mounted (){
        this.idnegocio =  this.$route.params.idnegocio;
        this.negocio = this.negocios.find(x=>x.tag ===this.idnegocio);
        let elindice =  this.negocios.indexOf(this.negocio)
        this.grupousuario = this.grupousarios[elindice];
        if(this.negocio.tipoNegocio.id === 7){
          this.headers= [
            { text: '', value: 'data-table-expand', sortable: false },
            { text: 'Acciones', value: 'action', sortable: false },
            { text: 'Nombre', align: 'left',  value: 'socioPrincipal.personaNombre'},
            { text: 'Apellido', align: 'left',  value: 'socioPrincipal.personaApellidoPaterno'},
            { text: 'Telefono', value: 'socioPrincipal.personaTelefono' },
            { text: 'Direccion', value: 'socioPrincipal.personaDireccion' },
            { text: 'Distrito', value: 'socioPrincipal.personaDistrito.distrito' },

          ]
        }else{
          this.headers= [
            { text: '', value: 'data-table-expand', sortable: false },
            { text: 'Acciones', value: 'action', sortable: false },
            {text: "Tipo Carnet", value: 'esctcarn', sortable: false},
            { text: 'Nombre', align: 'left',  value: 'socioPrincipal.personaNombre'},
            { text: 'Apellido', align: 'left',  value: 'socioPrincipal.personaApellidoPaterno'},
            { text: 'DNI', value: 'socioPrincipal.personaDni' },
            { text: 'Estado Carnet', value: 'estadoCarnet.estadoCarnet' },
            { text: 'Fecha Nacimiento', value: 'socioPrincipal.personaFechaNacimiento' },
            { text: 'Referido', value: 'referido' },
          ]
        }
        if (this.usuario.id === undefined){
          this.overlay = true
          firebase
              .auth()
              .onAuthStateChanged(user => {
                if(user){
                  this.overlay = false
                  this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
                  this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno
                  this.dametemporadas();
                }else{
                  this.overlay = false
                  this.$router.push({ path: '/' });
                }
              })
        }else{
          this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
          this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno
          this.dametemporadas();
        }
  },
   watch: {
    dialog (val) {
      val || this.close()
    },
     "$store.state.cliente": function (){
       this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
       this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno
       this.dametemporadas();
     },
    "$route.params.idnegocio"(value) {
      console.log(value)
           this.idnegocio =  this.$route.params.idnegocio
           this.negocio = this.negocios.find(x=>x.tag ===this.idnegocio)
       let elindice =  this.negocios.indexOf(this.negocio)
          this.grupousuario = this.grupousarios[elindice];
                   if (this.usuario.id === undefined){

                     this.$router.push({ path: '/' });
                   }else{
                     this.token = firebase.auth().currentUser.auth.currentUser.accessToken;

                     this.dametemporadas();
                     this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno
                   }
    },
     date () {
       this.editedItem.fechaNacimiento = this.formatDatee(this.date)
     },
     idtemporada(){
      this.damesocioss()
     }
  },
  methods : {
    formatDatee(value) {
      return moment(value).locale('es-pe').format("YYYY-MM-DD")
    },
    formatFecha(value) {
      return moment(value).locale('es-pe').format("DD/MM/YYYY")
    },
    format(value) {
      return moment(value).format('YYYY-MM-DD')
    },
    formatDateee(value) {
      return moment(value).locale('es-pe').format("YYYY-MM-DD hh:mm:ss")
    },
    formatDate (date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      return `${year}-${month}-${day}`;
    },
    parseDate (date) {
      if (!date) return null

      const [day,month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    reload( response){
      console.log(response);
    },
    verEdad(item) {
      if(item !==  null){
      item.replace("/","-")
      let diff = new Date().getUTCFullYear() -  new Date(item).getUTCFullYear();
      return diff;}else return ""

    },
    dameestadoscarnet(){
      axios
      .get('general/estadocarnets/'+this.negocio.tipoNegocio.id,{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      })
          .then(response => {
            this.estadocarnets = response.data

          })
          .catch((error)  => {
            this.overlay = false
            this.alerterror = true
            this.texterror = error
            this.progr = false;
          });
    },
    damesocioss(){
      this.progr = true;
      let bodyFormData = new FormData();
      bodyFormData.append('idtemporada', this.idtemporada);
      this.overlay = true
      axios
        .post('membresia/portemporada',bodyFormData,{
          headers: {
            'Authorization': `Bearer ${this.token}`,
          }
        })
        .then(response => {
          this.socios = response.data;
          this.personas = []
          response.data.forEach((entry)=>{

            let obj = {
              nombre : entry.socioPrincipal.personaNombre,
              appaterno: entry.socioPrincipal.personaApellidoPaterno,
              dni: entry.socioPrincipal.personaDni,
              email : entry.socioPrincipal.personaEmail,
              direccion: entry.socioPrincipal.personaDireccion,
              distrito : entry.socioPrincipal.personaDistrito.distrito,
              telefono : entry.socioPrincipal.personaTelefono,
              referido: entry.referido,
              edad: this.verEdad(entry.socioPrincipal.personaFechaNacimiento)
            }

            this.personas.push(obj)
          });
          this.dameestadoscarnet();
          this.diexcel = true
           this.progr = false;
            this.alertborrador = false;
            this.alertnuevo = false;
            this.alerteditar = false;
          this.overlay = false
        })
        .catch((error)  => {
        this.overlay = false
          this.alerterror = true
          this.texterror = error
          this.progr = false;
        });
    },
    damedistritos(){
      this.progr = true;
      axios
              .get('distritos/ciudad/'+this.negocio.ciudad.id,{
                headers: {
                  'Authorization': `Bearer ${this.token}`,
                }
              })
              .then(response => {
                this.distritos = response.data;
              })
              .catch((error)  => {
                this.alerterror = true
                this.texterror = error
              });
    },
     dametemporadas(){
      this.progr = true;
                      let urltempor = 'temporadas/negociotag/' + this.idnegocio  ;
      this.diexcel = false;
      axios
              .get(urltempor,{
                headers: {
                  'Authorization': `Bearer ${this.token}`,
                }
              })
              .then(response => {
                this.temporadas = response.data;
                this.idtemporada = this.temporadas[0].id
                this.damesocioss();
                this.damedistritos();
                this.dametiposdecarnet();
              })
              .catch((error)  => {
                this.alerterror = true
                this.texterror = error
              });
    },
    dametiposdecarnet(){
      this.progr = true;
      var bodyFormData = new FormData();
      bodyFormData.append('negociotag', this.idnegocio);
      bodyFormData.append('idtemporada', this.idtemporada);

      axios.post('tipocarnets/negociotemporada',bodyFormData,{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      })
              .then(response => {
                this.tiposcarnets = response.data;
              })
              .catch((error)  => {
                this.alerterror = true
                this.texterror = error
              });
    },
    editItem (item) {
      this.editedIndex = this.socios.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.editedItem.socioPrincipal.personaFechaNacimiento = this.formatDatee(this.editedItem.socioPrincipal.personaFechaNacimiento)
      this.dialog = true
    },
    zoomItem (item) {
      this.editedIndex = this.socios.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialogimage = true
    },
    cameraItem (item) {
      this.editedIndex = this.socios.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialoguploadimage = true
    },
    dniItem(item){
      this.editedIndex = this.socios.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialoguploadimagedni = true
      this.imagen = null
    },
      verCarnet(item){
          let ssalink = "https://tunay.app/micarnet/"+item.codigoUnico
          var anchor = document.createElement('a');
          anchor.href = ssalink;
          anchor.target="_blank";
          anchor.click();
      },
    onFileFotoChange(e) {
      this.editedItem.socioPrincipal.personaFoto= URL.createObjectURL(this.imagen)
      var bodyFormData = new FormData();
      bodyFormData.append("file",this.imagen);
      let url = "personas/foto/" + this.editedItem.socioPrincipal.personaId
      this.overlay = true
      axios
          .post(url,bodyFormData,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            console.assert(true,response);
            this.dialoguploadimage = false;
            this.overlay = false
          })
          .catch(error => {
            this.dialoguploadimage = false;
            this.error = "Hubo un error";
            this.alerterror = true;
            this.overlay = false
            this.texterror = error
          });
      console.log(e)
    },
    onFileChange(e) {
      this.editedItem.personaSocioDTO.personaDniFoto= URL.createObjectURL(this.imagen)
      var bodyFormData = new FormData();
      bodyFormData.append("file",this.imagen);
      let url = "personas/dni/" + this.editedItem.socioPrincipal.personaId
      this.overlay = true
      axios
          .post(url,bodyFormData,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            console.assert(true,response);
            this.dialoguploadimagedni = false;
            this.overlay = false
          })
          .catch(error => {
            this.error = "Hubo un error";
            this.alerterror = true
            this.texterror = error
          });
      console.log(e)
    },
    deleteItem (item) {
      this.editedIndex = this.socios.indexOf(item);
      this.dialogdelete = true;
    },
    cambiaTipoCarnet(item){
      this.editedIndex = this.socios.indexOf(item);
      this.overlay = true;
      var bodyFormData2 = new FormData();
      bodyFormData2.append("tipoCarnetId",this.socios[this.editedIndex].tipoCarnet.tipoCarnetId);
      bodyFormData2.append("membresiaid",this.socios[this.editedIndex].id);
      bodyFormData2.append("idusuario",this.usuario.id);

      axios
          .post('membresia/cambiatipocarnet',bodyFormData2,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            if(response.data){
              this.alerteditar = true
            }
            this.overlay = false
            this.progr = false;
          })
          .catch((error)  => {
            this.alerterror = true
            this.texterror = error
            this.progr = false;
          });
    },
    cambiaEstado (item) {
      console.log(item)
      this.overlay = true;
      var bodyFormData2 = new FormData();
      bodyFormData2.append("estadoid",item.estadoCarnet.id);
      bodyFormData2.append("membresiaid",item.id);
      bodyFormData2.append("idusuario",this.usuario.id);

      axios
              .post('membresia/cambiaestado',bodyFormData2,{
                headers: {
                  'Authorization': `Bearer ${this.token}`,
                }
              })
              .then(response => {
                if(response.data){
                  this.alerteditar = true
                }
                this.overlay = false
                this.progr = false;
              })
              .catch((error)  => {
                this.overlay = false
                this.alerterror = true
                this.texterror = error
                this.progr = false;
              });
    },

    borralo (){

      axios
      .delete('membresia/'+this.socios[this.editedIndex].id,{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      })
      .then(response => {
                console.log(response);
                 this.dialogdelete = false;
        this.alertborrador = true;
        this.damesocioss();
                })
      .catch(error => {
                    this.error = "Hubo un error";
        this.alerterror = true
        this.texterror = error
                });
    },
    close () {
      this.dialog = false;
      this.dialogdelete = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    forceFileDownload(response){
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'file.png') //or any other extension
      document.body.appendChild(link)
      link.click()
    },
    downloadWithAxios(urlr){
      axios({
        method: 'get',
        url: urlr,
        responseType: 'arraybuffer'
      })
              .then(response => {

                this.forceFileDownload(response)

              })
              .catch(() => console.log('error occured'))
    },
    save () {
      if (this.editedIndex > -1) {
        Object.assign(this.socios[this.editedIndex], this.editedItem);
        var bodyFormData = new FormData();
        bodyFormData.append("persona",JSON.stringify(this.editedItem.socioPrincipal));
        bodyFormData.append("referido",JSON.stringify(this.editedItem.referido));
        bodyFormData.append("membresiaid",this.socios[this.editedIndex].id);
        axios
      .post('membresia/editar',bodyFormData,{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      }).then(response => {
                console.log(response);
                this.alerteditar = true;
                this.damesocioss();
                })
            .catch(error => {
                    this.error = "Hubo un error";
              this.alerterror = true
              this.texterror = error
                });
      }
      this.close()
    },
  },
  computed: {
    // map `this.user` to `this.$store.getters.user`
    formTitle () {
      return this.editedIndex === -1 ? 'Nuevo Socio' : 'Editar Socio'
    },
    computedDateFormatted () {
      return this.formatDate(this.date)
    },
    ...mapGetters({
      user: "user",
      usuario: "usuario",
      negocios: "negocios",
      grupousarios:"grupousuarios",
      cliente:"cliente",
      sexos:"sexos"
    })
  }
};
</script>
<style scoped>
.grecaptcha-badge{
  display: none !important;
}
</style>